"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Selector for NATURALLY focusable elements
 * @type {String}
 */
var focusableSelector = ['a[href]', 'button:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'area[href]', 'iframe', 'object', 'embed', '[tabindex="0"]', '[contenteditable]', 'audio[controls]', 'video[controls]'].join(', ');
var _default = focusableSelector;
exports["default"] = _default;